import { request } from '../utils';
import store from '../store';

export default function vote(root: any, data: any, con, calback) {
    let ajaxData = {
        orderId: data.orderUuid,
        requestNo: '' + new Date().getTime() + store.user.userInfo.id
    };
    if (root) {
        Object.assign(ajaxData, {reason: con});
    }
    request(root, ajaxData).then((rd) => {
        if (rd.errCode == 200) {
            calback && calback(true, rd.errDesc);
        } else {
            calback && calback(false, rd.errDesc);
        }
    });
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/operates/vote.ts